import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/images/logo-lion-parcel-3x.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-cb2bde1a")

_pushScopeId("data-v-cb2bde1a")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "hidden" }, [
  /*#__PURE__*/_createVNode("img", {
    id: "lionparcel",
    alt: "",
    src: _imports_0
  }),
  /*#__PURE__*/_createVNode("img", {
    id: "list-pickup-manifest-barcode",
    alt: ""
  })
], -1)
const _hoisted_2 = {
  id: "pickup-manifest",
  class: "relative bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen w-full"
}
const _hoisted_3 = { class: "flex flex-col justify-between items-start border-b border-gray-lp-400 z-20 relative pt-8" }
const _hoisted_4 = { class: "flex flex-row py-6 align-middle items-center justify-between w-full" }
const _hoisted_5 = { class: "font-semibold text-20px mr-4 text-black-lp-200 title-layout flex flex-row align-middle justify-center" }
const _hoisted_6 = {
  class: "mr-8",
  style: {"align-self":"center"}
}
const _hoisted_7 = { class: "hidden" }
const _hoisted_8 = { class: "hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Breadcrumb),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.getTitle), 1),
            _createVNode(_component_time_range_picker, {
              onSelect: _ctx.setPeriode,
              default: _ctx.$t('7 hari terakhir')
            }, null, 8, ["onSelect", "default"])
          ]),
          (_ctx.ableToCreate)
            ? (_openBlock(), _createBlock(_component_lp_button, {
                key: 0,
                onClick: _ctx.goToCreate,
                title: _ctx.$t('Buat Pickup'),
                textColor: "white",
                disabled: !_ctx.validationAccount
              }, null, 8, ["onClick", "title", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_TableV2, {
        columns: _ctx.columns,
        data: _ctx.pickupManifestList,
        loading: _ctx.isLoading,
        pagination: _ctx.pagination,
        "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
        totalColumnFreeze: 1,
        isRightFreeze: "",
        onRequest: _ctx.fetchPickupManifestList,
        errorCause: _ctx.errorCause
      }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "errorCause"]),
      _withDirectives(_createVNode("div", _hoisted_7, null, 512), [
        [_directive_click_outside, () => (_ctx.chevronUp = _ctx.chevronUp.map(() => false))]
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("img", {
          id: "logo-receipt",
          src: require(`@/app/ui/assets/images/logo-${_ctx.roleAccount}.png`),
          alt: ""
        }, null, 8, ["src"])
      ])
    ]),
    (_ctx.isErrorPrintList && !_ctx.isLoadingPrintList)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCausePrintList,
          onCancel: _ctx.closeModalErrorPrintList,
          onTryAgain: _ctx.printManifestTryLoad,
          modal: ""
        }, null, 8, ["errorType", "onCancel", "onTryAgain"]))
      : _createCommentVNode("", true)
  ], 64))
})